import { ssoApiClient } from './apiClient';

export const registerService = {
  async register({ fullName, email, phoneNumber, password, nic, dateOfBirth, gender, agreeToTerms, province, district }) {
    const payload = {
      full_name: fullName,
      email: email || null,
      phone_number: phoneNumber,
      password: password,
      role: 'student',
      nic: nic || '',
      has_grading_access: true,
      has_ims_access: false,
      has_lms_access: true,
      registered_method: 'student_web',
      agree_to_terms: !!agreeToTerms,
      date_of_birth: dateOfBirth ? new Date(dateOfBirth).toISOString() : '2000-01-01T00:00:00.000Z',
      gender: gender || 'male',
      is_self_registered: true,
      country: 'Sri Lanka',
      province: province || '',
      district: district || '',
      job_title: '',
      postal_address: '',
      reference_code: '',
      added_by: ''
    };

    const response = await ssoApiClient.post('/sso-auth/register', payload);

    if (response && response.isSuccessful) {
      return response.content;
    }

    throw new Error(response?.message || 'Registration failed');
  }
};

export default registerService;
